<template>
    <LoadingAspn
        type="news-1"
        v-if="newsPagination.isLoading && newsPagination.firstLoading"
    ></LoadingAspn>
    <div class="w-100" v-else>
        <div
            :class="{ 'pa-05rem': isMobile }"
            v-if="news.length === 0 && !newsPagination.isLoading"
        >
            <NoData text="NO_NEWS" />
        </div>
        <template v-else>
            <ListLazyload @onLoad="loadMore()" :pagination="newsPagination">
                <div class="news-container">
                    <div v-if="!isMobile">
                        <router-link
                            :to="{
                                name: 'newsDetail',
                                params: {
                                    title: news[0].urlName,
                                    id: news[0].id,
                                    currentSportType: news[0].sportTypePath,
                                },
                            }"
                            tag="div"
                            class="news-item first"
                            v-if="news[0]"
                        >
                            <div class="news-image">
                                <img
                                    class="news-image--coverImg"
                                    :src="`${s3ImgUrl}/${news[0].coverImage}`"
                                />
                            </div>
                            <div class="news-content">
                                <div class="news-title">
                                    {{ news[0].title }}
                                </div>
                                <div class="news-date">
                                    {{ news[0].publishedOn }}
                                </div>
                            </div>
                        </router-link>
                        <div class="news-list">
                            <template
                                v-for="(item, index) in news"
                                :key="index"
                            >
                                <router-link
                                    :to="{
                                        name: 'newsDetail',
                                        params: {
                                            title: item.urlName,
                                            id: item.id,
                                            currentSportType:
                                                item.sportTypePath,
                                        },
                                    }"
                                    tag="div"
                                    class="news-item"
                                    v-if="index > 0"
                                >
                                    <div class="news-image">
                                        <img
                                            class="news-image--coverImg"
                                            :src="`${s3ImgUrl}/${item.coverImage}`"
                                        />
                                    </div>
                                    <div class="news-content">
                                        <div class="news-title">
                                            {{ item.title }}
                                        </div>
                                        <div class="news-date">
                                            {{ item.publishedOn }}
                                        </div>
                                    </div>
                                </router-link>
                            </template>
                        </div>
                    </div>

                    <template v-else>
                        <div class="news-list">
                            <template
                                v-for="(item, index) in news"
                                :key="index"
                            >
                                <router-link
                                    :to="{
                                        name: 'newsDetail',
                                        params: {
                                            title: item.urlName,
                                            id: item.id,
                                            currentSportType:
                                                item.sportTypePath,
                                        },
                                    }"
                                    tag="div"
                                    class="news-item"
                                    :class="{
                                        first: index === 0,
                                    }"
                                >
                                    <div class="news-image relative">
                                        <div
                                            class="ratio-169-container"
                                            v-if="isMobile && index === 0"
                                        ></div>
                                        <div
                                            class="ratio-32-container"
                                            v-else-if="isMobile && index !== 0"
                                        ></div>
                                        <img
                                            class="news-image--coverImg"
                                            :src="`${s3ImgUrl}/${item.coverImage}`"
                                            :class="{
                                                'ratio-32-content':
                                                    isMobile && index !== 0,
                                                'ratio-169-content':
                                                    isMobile && index === 0,
                                            }"
                                        />
                                    </div>
                                    <div class="news-content">
                                        <div class="news-title">
                                            {{ item.title }}
                                        </div>
                                        <div class="news-date">
                                            {{ item.publishedOn }}
                                        </div>
                                    </div>
                                </router-link>
                            </template>

                            <div class="news-mobile-ads-box">
                                <img
                                    src="../../../../../static/images/icons/aspn_icon/player/news_ads_mobile_1.png"
                                    class="news-mobile-ads"
                                />
                            </div>

                            <div class="news-mobile-ads-box">
                                <img
                                    src="../../../../../static/images/icons/aspn_icon/player/news_ads_mobile_2.png"
                                    class="news-mobile-ads"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </ListLazyload>

            <div class="display-flex-align-fs">
                <van-loading v-if="newsPagination.isLoading" />
            </div>
            <!-- <div v-if="!newsPagination.isLoading" class="skeleton-child h-100"></div> -->

            <!-- <div class="load-more" 
                    v-if="!newsPagination.lastPage"
                    @click="loadMore()">
                    {{ $t('SEE_MORE') }}
                </div> -->
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";
import moment from "moment";
export default {
    name: "teamNews",
    data() {
        return {
            count: 50,
            s3ImgUrl: config.s3ImgUrl,
            news: [],
            // league news
            newsPagination: {
                pageNo: 1,
                sportType: "SOCCER",
                pageSize: 10,
                lastPage: false,
                isLoading: false,
                firstLoading: true,
            },
        };
    },
    computed: {
        ...mapGetters(["isMobile"]),
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions(["getNewsListByTeam"]),
        init() {
            this.getNewsListByTeamData();
        },
        async getNewsListByTeamData(loadMore = false) {
            this.newsPagination.isLoading = true;

            let params = {
                teamIds: this.$route.params.teamKey,
                sportType: "SOCCER",
                pageNo: this.newsPagination.pageNo,
                pageSize: this.newsPagination.pageSize,
            };
            const result = await this.getNewsListByTeam(params);
            if (result.errorCode === 0) {
                if (!loadMore) {
                    this.news = this.generateNewsList(result.result.content);
                } else {
                    const list = this.generateNewsList(result.result.content);
                    this.news = this.news.concat(list);
                }

                if (result.result.last) {
                    this.newsPagination.lastPage = true;
                }
            }
            this.newsPagination.isLoading = false;
            this.newsPagination.firstLoading = false;
        },
        generateNewsList(data) {
            for (let x = 0; x < data.length; x++) {
                let convertedDate;
                let A = moment(data[x].publishedOn);
                let B = moment();
                let diffDays = A.diff(B, "days");

                if (diffDays > 0) {
                    convertedDate = moment(data[x].publishedOn).fromNow();
                } else {
                    convertedDate = moment(data[x].publishedOn).format(
                        "dddd D MMM YYYY"
                    );
                }
                let theNewsData = data[x];
                if (theNewsData.sportType == "SOCCER") {
                    theNewsData.sportTypePath = "football";
                } else {
                    theNewsData.sportTypePath =
                        theNewsData.sportType.toLowerCase();
                }
                data[x].urlName = data[x].title
                    .toLowerCase()
                    .replace(/\s/g, "-");
                data[x].publishedOn = moment(data[x].publishedOn).fromNow(); //moment("2019-09-10T07:53:06.000+00:00").fromNow(); //
            }
            return data;
        },
        loadMore() {
            this.newsPagination.pageNo += 1;
            this.getNewsListByTeamData(true);
        },
        onLoad() {
            this.count += 10;
        },
    },
};
</script>

<style scoped>
.news-container {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
}
.news-list {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, calc(25% - 18px));
}
</style>

<style scoped src="../../../../assets/css/news/index.css"></style>
